import React, {useState} from 'react';

import {Link} from 'react-router';

import {RenameListItem} from 'app/components/general/RenameListItem';
import {useCurrentUserState} from 'app/current-user/api';
import {DeleteDocumentModal} from 'app/general/modals/DeleteDocumentModal';
import {ActionsButton} from 'app/general/widgets/ActionsButton';
import {StyledDocItem} from 'app/procedures/styles';
import {useUpdateTag} from 'app/tags/api';
import {
  POLICIES_DASHBOARD_URL,
  PROCEDURES_HOME,
  PROCESS_DASHBOARD_URL,
} from 'app/urls';
import {getObjectName} from 'app/utils/fallbacks';
import {gt} from 'app/utils/i18n';

import type {TagSerializedType} from 'sweet-types';

type Props = {
  tag: TagSerializedType;
};
export const CompactTagListItem = ({tag}: Props) => {
  const {is_super_manager} = useCurrentUserState().data!;

  const [isEditing, setEditing] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [updateTag] = useUpdateTag();

  return (
    <>
      <StyledDocItem className="row border-top py-2 d-flex align-items-center">
        <div className="col d-flex align-items-center text-truncate">
          <div className="text-dark font-weight-bold row align-items-center no-gutters align-items-center flex-grow-1">
            <div className="col-auto mr-1">
              <i className="fa fa-fw fa-tag" />
            </div>
            <div className="col text-truncate">
              {isEditing ? (
                <RenameListItem
                  initialValue={tag.name}
                  onSave={(name) => updateTag({...tag, name})}
                  onCancel={() => setEditing(false)}
                />
              ) : (
                getObjectName(tag, 'tag', true)
              )}
            </div>
          </div>
        </div>
        <div className="col-auto pl-1 align-items-center">
          <Link
            className="badge badge-light d-block"
            to={`${PROCEDURES_HOME}?tag=${tag.slug}`}
          >
            <i className="far fa-file" /> {tag.procedure_count}
          </Link>
        </div>
        <div className="col-auto pl-1 align-items-center">
          <Link
            className="badge badge-light d-block"
            to={`${POLICIES_DASHBOARD_URL}?tag=${tag.slug}`}
          >
            <i className="fa fa-umbrella" /> {tag.policy_count}
          </Link>
        </div>
        <div className="col-auto pl-1 align-items-center">
          <Link
            className="badge badge-light d-block"
            to={`${PROCESS_DASHBOARD_URL}?tag=${tag.slug}`}
          >
            <i className="far fa-copy" /> {tag.proceduregroup_count}
          </Link>
        </div>
        {is_super_manager ? (
          <div className="col-auto pl-1">
            <ActionsButton
              actions={[
                {
                  text: gt('Rename'),
                  icon: 'fa fa-pen',
                  key: 'rename',
                  callback: () => setEditing(true),
                },
                {
                  text: gt('Delete'),
                  icon: 'far fa-trash',
                  key: 'trash',
                  callback: () => setShowDeleteModal(true),
                },
              ]}
            />
          </div>
        ) : null}
      </StyledDocItem>
      {showDeleteModal != null ? (
        <DeleteDocumentModal
          show={showDeleteModal}
          object={{...tag, content_type: 'tag'}}
          redirectContentType={'tag'}
          onClose={() => setShowDeleteModal(false)}
        />
      ) : null}
    </>
  );
};
